var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showCallWidget)?_c('div',{staticClass:"callback-bt",attrs:{"type":"button"},on:{"click":function($event){return _vm.$emit('ClickCallWidget')}}},[_vm._m(0)]):_vm._e()
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-call"},[_c('i',{staticClass:"fa fa-phone"})])
}]

export { render, staticRenderFns }